import { render, staticRenderFns } from "./McpClientSwitcher.vue?vue&type=template&id=5df4323e&scoped=true"
import script from "./McpClientSwitcher.vue?vue&type=script&lang=js"
export * from "./McpClientSwitcher.vue?vue&type=script&lang=js"
import style0 from "./McpClientSwitcher.vue?vue&type=style&index=0&id=5df4323e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4323e",
  null
  
)

export default component.exports